import axios from "axios";
import { toast } from "react-toastify";
import i18n from "i18next";
import {
  TMessageType,
  TRequestResponseResult,
  TResponseCode,
} from "utils/netCall/types";

async function RequestErrorHandling<T>(req: TRequestResponseResult<T>) {
  req.messages.forEach((msg: any) => {
    // console.log(msg.message);
    switch (msg.type) {
      case TMessageType.Error:
        toast.error(msg.messageCode + " : " + msg.message);
        break;
      case TMessageType.Warning:
        toast.warning(msg.messageCode + " : " + msg.message);
        break;
      case TMessageType.Information:
        toast.info(msg.messageCode + " : " + msg.message);
        break;
      default:
        break;
    }
  });

  switch (req.responseCode) {
    case TResponseCode.Error:
      toast.error(i18n.t("rest-Error"));
      break;

    case TResponseCode.CreatingError:
      toast.error(i18n.t("rest-CreatingError"));
      break;
    case TResponseCode.UpdateError:
      toast.error(i18n.t("rest-UpdateError"));
      break;
    case TResponseCode.GetError:
      toast.error(i18n.t("rest-GetError"));
      break;
    case TResponseCode.DeleteError:
      toast.error(i18n.t("rest-DeleteError"));
      break;

    case TResponseCode.IdNotExist:
      toast.error(i18n.t("rest-IdNotExist"));
      break;

    case TResponseCode.CreatingUserError:
      toast.error(i18n.t("rest-CreatingUserError"));
      break;
    case TResponseCode.SetPasswordError:
      toast.error(i18n.t("rest-SetPasswordError"));
      break;
    case TResponseCode.UserNotFound:
      toast.error(i18n.t("rest-UserNotFound"));
      break;
    case TResponseCode.UpdatingUserError:
      toast.error(i18n.t("rest-UpdatingUserError"));
      break;
    case TResponseCode.RoleAlreadyExist:
      toast.error(i18n.t("rest-RoleAlreadyExist"));
      break;
    case TResponseCode.UserAlreadyExistInDb:
      toast.error(i18n.t("rest-UserAlreadyExistInDb"));
      break;
    case TResponseCode.UserAlreadyExistInIdentityServer:
      toast.error(i18n.t("rest-UserAlreadyExistInIdentityServer"));
      break;
    case TResponseCode.PasswordIsRequired:
      toast.error(i18n.t("rest-PasswordIsRequired"));
      break;

    case TResponseCode.WatermeterAlreadyExist:
      toast.error(i18n.t("rest-WatermeterAlreadyExist"));
      break;
    case TResponseCode.WatermeterAlreadyInstalled:
      toast.error(i18n.t("rest-WatermeterAlreadyInstalled"));
      break;
    case TResponseCode.IdentifierIdExist:
      toast.error(i18n.t("rest-IdentifierIdExist"));
      break;
    case TResponseCode.ApartmentNotExist:
      toast.error(i18n.t("rest-ApartmentNotExist"));
      break;
    case TResponseCode.CityNotExist4Jurisdiction:
      toast.error(i18n.t("rest-CityNotExist4Jurisdiction"));
      break;
    case TResponseCode.ProvinceNotExist4Jurisdiction:
      toast.error(i18n.t("rest-ProvinceNotExist4Jurisdiction"));
      break;
    case TResponseCode.WaterMeterIsNot4Customer:
      toast.error(i18n.t("rest-WaterMeterIsNot4Customer"));
      break;
    case TResponseCode.WatermeterNotAssigned2WaterSubscriber:
      toast.error(i18n.t("rest-WatermeterNotAssigned2WaterSubscriber"));
      break;
    case TResponseCode.WatermeterAlreadyAssigned2WaterSubscriber:
      toast.error(i18n.t("rest-WatermeterAlreadyAssigned2WaterSubscriber"));
      break;

    case TResponseCode.FetchDataFromLoraServerError:
      toast.error(i18n.t("rest-FetchDataFromLoraServerError"));
      break;
    case TResponseCode.ProcessDataError:
      toast.error(i18n.t("rest-ProcessDataError"));
      break;

    default:
      break;
  }
}

export { RequestErrorHandling };
